'use client'
import React, {useState} from "react";
import NewsletterForm from "@/components/ContentElements/Forms/NewsletterForm";
import Column from "@/components/ContentElements/Grid/Column";
import Container from "@/components/ContentElements/Grid/Container";
import {useTranslations} from "next-intl";


export interface FormRenderer {
    formName: string
}

const SelectedForm = ({formName, children, className, setIsSubmitting}: {formName: string, children: React.ReactNode, className?: string, setIsSubmitting:React.Dispatch<React.SetStateAction<boolean>>}) => {
    switch (formName){
        case 'newsletter':
            return <NewsletterForm className={className} setIsSubmitting={setIsSubmitting}>{children}</NewsletterForm>
        default:
            return ''
    }
}

export default function FormRenderer({formName}:FormRenderer ) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const t = useTranslations("Forms")
    return (
        <Container>
            <Column width="1">
                <SelectedForm formName={formName} className="max-w-[600px] w-fill mx-auto flex gap-xl flex-col" setIsSubmitting={setIsSubmitting}>
                    <button type="submit" disabled={isSubmitting} className="ml-auto w-fit bg-black text-white text-above font-bonprix rounded border border-black px-2xl py-s brand-transition hover:bg-white hover:text-black focus-visible:outline-offset-[5px] focus-visible:outline-2 focus-visible:outline-outline focus-visible:bg-white focus-visible:text-black focus:hover:outline-none focus-visible:hover:outline-none outline-outline"> {isSubmitting ? t("loading") : t("submit")}</button>
                </SelectedForm>
            </Column>
        </Container>
    )
};